<app-breadcrumb></app-breadcrumb>

<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div class="d-flex justify-content-between align-items-center">
    <h2 class="ms-4 roboto-medium">Resolution Orders</h2>
    <span class='b2 me-4 roboto-medium' *ngIf="shouldHide" (click)=reOpenHistory()>REOPEN</span>
</div>

<div class="grid-agg ms-4 me-4 px-0">
    <ag-grid-angular 
        class="ag-theme-balham grid-items res_orders_comp"
        (gridReady)="onGridReady($event);"
        (window:resize)="sizeToFit()"
        [rowHeight]="rowHeight"
        [animateRows]="true" [rowData]="displayRowData"
        [defaultColDef]="defaultColDef"   [columnDefs]="columnDefs" 
        [suppressPaginationPanel]="true"  [headerHeight]="40"
        [floatingFiltersHeight]="40" [icons]="icons" (paginationChanged)="onPaginationChanged()" [pagination]="true"
        [paginationPageSize]="paginationPageSize" [theme]="'legacy'"
        [rowClassRules]="rowClassRules" (filterChanged)="onFilterChanged($event)" >
    </ag-grid-angular>
    <div class="d-flex pagination px-2 align-items-center justify-content-between">
        <div>
            <div>
                <label class="page-drpdwn-label me-2">Records/Page: </label>
                <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value={{rowCount}}>ALL</option>
                </select>
            </div>
        </div>
        <div class="d-flex align-items-center gap-3">
            <div>Viewing Records</div>


            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
                class="text-primary reverse firstPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <img src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()" class="text-primary reverse previousPage"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

            <div>
                (
                <span class="value" id="lbCurrentPage"></span> -
                <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
                <span>{{rowCount}}</span>
            </div>


            <img src="assets/images/Icon metro-next.svg" (click)="goToNexpage()" class="text-primary nextPage"
                [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
            <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
                class="text-primary lastPage" [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
        </div>
    </div>
</div>